Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};
Greenmile.PanelBuilder.Fields = Greenmile.PanelBuilder.Fields || {};

Greenmile.PanelBuilder.Fields.Base = (function () {

    function Base (field, entity) {

        field = field || { type: 'TEXT' };
        this.pickListComparator = new Monet.UI.Fields.PickList();
        this.comparators = Greenmile.PanelBuilder.Comparator.Fields[field.type];
        this.field = field;

        var setValueBaseFields = function (data) {
            this.id = data.id;
            this.pickListComparator.setValue(data.operation);
            field = data.entityField;
            this.rootEl.removeChild(this.rootEl.childNodes[this.rootEl.childElementCount - 1]);
            this.rootEl.appendChild(this.renderField());
            this.fieldRendered.setValue(Greenmile.PanelBuilder.Utils.getValueToUserFormat(field, this.convertSecondsToUserTimezone(data.value)));
            this.postRender();

        }.bind(this);

        this.getValue = function () {
            var value = {
                entityField: { id: field.id },
                attribute: Greenmile.PanelBuilder.Utils.getAttributeName(field),
                operation: this.pickListComparator.getValue(),
                value: Greenmile.PanelBuilder.Utils.getValueToServer(field, this.convertSecondsToUtc(this.fieldRendered.getFilterValue()))
            };

            if (this.id) {
                value.id = this.id;
            }
            return value;
        };

        this.setValue = function (data) {
            setValueBaseFields(data);
        }.bind(this);


        this.getPickListComparator = function () {
            var fieldDomains = [];
            this.pickListComparator.setId('panelbuilder_comparator');
            this.pickListComparator.setTextLabel('');
            this.pickListComparator.setInputName('comparator');
            this.pickListComparator.setMandatory(true);

            for (var i = 0, length = this.comparators.length; i < length; i++) {
                var comp = this.comparators[i];
                fieldDomains.push({ description: comp.label, value: comp.value });
            }

            this.pickListComparator.setFieldDomains(fieldDomains);
            this.pickListComparator.render();
            this.pickListComparator.input.removeChild(this.pickListComparator.input[0]);

            return this.pickListComparator.rootEl;

        }.bind(this);

        this.overrideFieldTypes = function () {
            if (['LOOKUP', 'LOOKUP_LIST'].indexOf(field.type) !== -1) {
                field.type = 'POWER_LOOKUP_LIST_FILTER';
            } else if (['DATE_TIME'].indexOf(field.type) !== -1) {
                field.type = 'TIME_MINUTES_SECONDS';
            }
        };

        this.convertSecondsToUtc = function (fieldValue) {
            if (field.type === 'SECONDS' || field.type === 'TIME_MINUTES_SECONDS') {
                return fieldValue + new Date().getTimezoneOffset() * 60;
            }
            return fieldValue;
        };

        this.convertSecondsToUserTimezone = function (fieldValue) {
            if (field.type === 'SECONDS' || field.type === 'TIME_MINUTES_SECONDS') {
                return (fieldValue - new Date().getTimezoneOffset() * 60);
            }
            return fieldValue;
        };

        this.renderField = function () {

            var threatPickListFields = function() {
                if(field.type === 'PICKLIST') {
                    this.fieldRendered.addPostRender(function() {

                    for( var i = 0; i < this.fieldRendered.input.length; i++) {
                        var value = this.fieldRendered.input[i].value.trim();
                        if(!value || (field.name === 'route.status' && value === 'COMPLETED')) {
                            this.fieldRendered.input.removeChild(this.fieldRendered.input[i]);
                            i--;
                        }
                    }

                    }.bind(this));

                }
            }.bind(this);

            this.overrideFieldTypes();
            var render = new Monet.UI.Fields.Render(field, entity);
            this.fieldRendered = render.render();
            this.postRender();
            threatPickListFields();
            return this.fieldRendered.rootEl;
        };

        this.render = function () {
            this.rootEl = document.createElement('div');

            this.rootEl.appendChild(this.getPickListComparator());

            if (this.renderField) {
                this.rootEl.appendChild(this.renderField());
            }

            return this.rootEl;
        };

        this.postRender = function () {
            if (this.fieldRendered.postRender) {
                this.fieldRendered.postRender();
            }
        };

    };

    return Base;

}());